import List from "./List";
import Annotation from "./Annotation";
import TruncatedTextContent from "./Annotation/TextContent/Truncated";

export default {
  List,
  Annotation,
  TruncatedTextContent
};
